import Listing from 'app/shared/model/Listing';
import KeyPager from 'app/shared/model/KeyPager';
import PaidInclusionReleaseDate from 'app/shared/model/PaidInclusionReleaseDate';
import PaidInclusionExistingStatesUpdate from 'app/shared/model/PaidInclusionExistingStatesUpdate';

const Listings = ({
    listings = [],
    paidInclusionReleaseDates = [],
    paidInclusionExistingStatesUpdate = {},
    maintenancePartner = {},
    numActiveListings = 0,
    numInactiveListings = 0,
    numTotalListings = 0,
    statsDaysBack = 0,
    pager = {},
    restrictions = {},
} = {}) => ({
    listings: listings.map(item => Listing(item)),
    paidInclusionReleaseDates: paidInclusionReleaseDates.map(item => PaidInclusionReleaseDate(item)),
    paidInclusionExistingStatesUpdate: PaidInclusionExistingStatesUpdate(paidInclusionExistingStatesUpdate),
    maintenancePartner: Object(maintenancePartner),
    numActiveListings: Number(numActiveListings),
    numInactiveListings: Number(numInactiveListings),
    numTotalListings: Number(numTotalListings),
    statsDaysBack: Number(statsDaysBack),
    pager: KeyPager(pager),
    restrictions: Object(restrictions),
});

export default Listings;
